import StaffMemberCompensationSection from './StaffMemberCompensationSection.container';

export default StaffMemberCompensationSection;
